/* eslint-env browser */
const containerElement = document.getElementById('search');
const searchsuggestions = containerElement && containerElement.getAttribute('data-searchsuggestions');

export const SEARCHSUGGESTIONS = searchsuggestions || 'SEARCHSUGGESTIONS';
